import React from "react";
import { Link, useHistory } from "react-router-dom";
import styled, { css } from "styled-components/macro";
import logo from "../../assets/logo.png";

import { FaTimes } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";

//svgs
import { ReactComponent as Loan } from "../../assets/icons/loan.svg";
import { ReactComponent as History } from "../../assets/icons/history.svg";
import { ReactComponent as Settings } from "../../assets/icons/settings.svg";
import { ReactComponent as Profile } from "../../assets/icons/profile.svg";
import { ReactComponent as Help } from "../../assets/icons/help.svg";

const Sidebar = ({ isopen, toggle }) => {
	const history = useHistory();
	const superAdmin = localStorage.getItem("super-admin-token");
	const logOut = () => {
		localStorage.removeItem("admin-token");
		localStorage.removeItem("admin");
		localStorage.removeItem("admin");
		localStorage.removeItem("super-admin-token");
		history.push("/");
	};
	return (
		<Container isopen={isopen}>
			<div>
				<Link to="/">
					<img src={logo} alt="logo" style={{ width: "120px" }} />
				</Link>
				<Close onClick={toggle} />
			</div>

			<Tabs>
				<div>
					<TabsBtn to="/admin-dashboard" onClick={toggle}>
						<Loan /> Dashboard
					</TabsBtn>

					<TabsBtn to="/admin-dashboard/customers" onClick={toggle}>
						<History />
						Customers
					</TabsBtn>
					<TabsBtn to="/admin-dashboard/disbursements" onClick={toggle}>
						<History />
						Loans
					</TabsBtn>
					<TabsBtn to="/admin-dashboard/repayments" onClick={toggle}>
						<History />
						Repayment
					</TabsBtn>
					{superAdmin ? (
						<TabsBtn to="/admin-dashboard/show" onClick={toggle}>
							<History />
							Admins
						</TabsBtn>
					) : null}
				</div>

				<div>
					<TabsBtn to="/admin-dashboard/settings" onClick={toggle}>
						<Settings />
						Settings
					</TabsBtn>
					{superAdmin ? (
						<TabsBtn to="/admin-dashboard/show" onClick={toggle}>
							<Profile />
							Super Admin
						</TabsBtn>
					) : (
						<TabsBtn to="/admin-dashboard/login" onClick={toggle}>
							<Profile />
							Super Admin
						</TabsBtn>
					)}
					<TabsBtn to="/admin-dashboard/help" onClick={toggle}>
						<Help />
						Help
					</TabsBtn>
					<TabsBtn to="/" onClick={logOut}>
						<FiLogOut />
						Logout
					</TabsBtn>
				</div>
			</Tabs>
		</Container>
	);
};

export default Sidebar;

//styles
const Container = styled.div`
	display: flex;
	flex-direction: column;
	height: calc(100vh - calc(100vh - 100%));
	background: #4d4f5c;
	width: 200px;
	z-index: 100;
	position: fixed;
	left: 0;
	top: 0;

	@media screen and (max-width: 600px) {
		display: ${({ isopen }) => (isopen ? "flex" : "none")};
		left: ${({ isopen }) => (isopen ? "0" : "-100%")};
		transition: 0.5s ease-in-out;
	}

	div {
		display: flex;
		align-items: center;
		background: #43425d;
		padding: 1rem;
		color: #fff;
		height: 60px;
		font-size: 14px;
		font-weight: 400;
		position: relative;
	}
`;

const Close = styled(FaTimes)`
	display: none;

	@media screen and (max-width: 600px) {
		display: flex;
		width: 25px;
		height: 25px;
		position: absolute;
		right: 1rem;
	}
`;

const Tabs = styled.section`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 3rem 0 1rem 2rem;
	height: 100%;

	div {
		display: flex;
		flex-direction: column;
		align-items: start;
		background: transparent;
		padding: 0;
		height: auto;
	}
`;

const btnstyle = css`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 8px 15px;
	border-radius: 3px;
	cursor: pointer;
	font-size: 12px;
	color: #fff;
	background: transparent;
`;

const TabsBtn = styled(Link)`
	${btnstyle};
	justify-content: start;
	padding: 0;
	margin-bottom: 2rem;
	outline: none;
	border: none;
	font-weight: 200;
	font-size: 14px;
	width: 100%;

	svg {
		margin-right: 10px;
	}
`;
